import { combineReducers } from "redux";
import { configurationNavigationPathsReducer } from "./Additional/configurationNavigationPathsReducer";
import { configurationNavigationReducer } from "./Additional/configurationNavigationReducer";
import { configurationOptionsReducer } from "./Additional/configurationOptionsReducer";
import { configurationUnitsReducer } from "./Additional/configurationUnitsReducer";
import { currenciesReducer } from "./Additional/currenciesReducer";
import { lastChangesReducer } from "./Additional/lastChangesReducer";
import { localStateReducer } from "./LocalState";
import { configurationReducer } from "./ServerState/configurationReducer";
import { noticeReducer } from "./ServerState/noticeReducer";
import { pathReducer } from "./ServerState/pathReducer";
import { problemDetailsReducer } from "./ServerState/problemDetailsReducer";
import { selectorsReducer } from "./ServerState/selectorsReducer";
import { sessionIdReducer } from "./ServerState/sessionIdReducer";
import { syncStateReducer } from "./ServerState/syncStateReducer";
export const configurationRootReducer = combineReducers({
    configuration: configurationReducer,
    options: configurationOptionsReducer,
    configurationUnits: configurationUnitsReducer,
    currencies: currenciesReducer,
    problemDetails: problemDetailsReducer,
    notice: noticeReducer,
    sessionId: sessionIdReducer,
    syncState: syncStateReducer,
    localState: localStateReducer,
    lastChanges: lastChangesReducer,
    configurationNavigationPaths: configurationNavigationPathsReducer,
    configurationNavigation: configurationNavigationReducer,
    selectors: selectorsReducer,
    path: pathReducer,
});
//# sourceMappingURL=configurationRootReducer.js.map